<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="cancelEdit()">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="text-center mb-4">
            <span class="modal-title">{{ 'ORGANIZATION_SETTINGS_FORM.TITLE' | translate | uppercase }}</span>
        </div>
        <form role="form" [formGroup]="formEdit" novalidate>
            <div class="form-group">
                <ng-select [dropdownPosition]="'bottom'" [items]="settingTypes" bindValue="id" bindLabel="description"
                    (change)="changeSettingType($event.id)" formControlName="settingTypes" [multiple]="false"
                    [clearable]="false" required>
                </ng-select>
            </div>
            <div class="form-group">
                <textarea rows="12" class="form-control" ngbAutofocus
                    placeholder="{{ 'ORGANIZATION_SETTINGS_FORM.JSON_FIELD_PLC' | translate }}"
                    formControlName="settingsJson" (focusout)="onFocusOutSettingsJsonEvent()"></textarea>
            </div>
            <div class="text-left mb-0 error-message" [ngClass]="{'json-is-not-correct': !isJsonFieldValid()}">
                <span class="">{{ 'ORGANIZATION_SETTINGS_FORM.JSON-IS-INVALID' | translate | uppercase }}</span>
            </div>
            <div class="text-left mb-0 information-message" [ngClass]="{'is-saved': isSaved, 'is-not-saved': !isSaved}">
                <span class="">{{ 'ORGANIZATION_SETTINGS_FORM.SAVED-SUCCESSFULLY' | translate | uppercase }}</span>
            </div>
            <div class="text-left mb-0 error-message" [ngClass]="{'unsuccessfully-save': isSaveError}">
                <span class="">{{ 'ORGANIZATION_SETTINGS_FORM.SAVE-ERROR' | translate | uppercase }}</span>
            </div>
        </form>
        <div class="d-flex justify-content-center mt-4 button-margin">
            <button type="button" class="modal-ok-btn" [disabled]="!enableSaveBtn()" (click)="saveData()">
                {{ 'CONSTANTS.BTN_SAVE' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>